import React, {useState, useEffect, useRef, useMemo, forwardRef, useImperativeHandle} from 'react'
import {Image, Space, PreviewGroup, Modal, Form, Row, Col} from '@bedrock/components'
import _ from 'lodash'
import {useControllableValue} from "ahooks";
import SFormItem from '@mpc/common/src/components/SForm/SFormItem';

const UserFormItems= [
  {
    label: "姓名",
    componentClass: "input",
    formItemKey: "name",
    required: true,
  },
  {
    label: "职位",
    componentClass: "input",
    formItemKey: "position",
    required: true,
  },
  {
    label: "邮箱",
    componentClass: "input",
    formItemKey: "mail",
    required: true,
  },
  {
    label: "电话",
    componentClass: "input",
    formItemKey: "tel",
    required: true,
  },
]


export type UserObj = {
  name: string,
  position: string,
  mail: string,
  tel: string,
}

type UserlistProps = {
  view?: boolean,
  value?: UserObj[],
  onChange?: (value: UserObj[]) => void
}


const defaultUserObj = {
  name: "",
  position: "",
  mail: "",
  tel: "",
}

 const UserList = forwardRef(function (props: UserlistProps, ref) {
  const {view} = props
  const [dataList, setDataList] = useControllableValue<UserObj[]>(props, {
    defaultValue: [defaultUserObj]
  })

  const [form] = Form.useForm()
  const handleChange = (allValues) => {
    // 比较两个对象是否相等
    const res = Object.keys(allValues).reduce((prev, key) => {
      const [index, formItemKey] = key.split('_')
      if(!prev[index]) {
        prev[index] = {}
      }
      prev[index][formItemKey] = allValues[key]
      return prev
    }, [])
    if(_.isEqual(dataList, res)) return
    setDataList(res)
  }

  const showData = useMemo(() => {
    const res = {}
    dataList?.forEach?.((item, index) => {
      Object.keys(item).forEach(key => {
        res[`${index}_${key}`] = item[key]
      })
    })
    return res
  }, [dataList])

  useEffect(() => {
    form.setFieldsValue(showData)
  }, [showData]);

  useEffect(() => {
    if(!dataList?.length) {
      setDataList([defaultUserObj])
    };
  }, [dataList]);

  useImperativeHandle(ref, () => ({
    validateFields: () => {
      return form.validateFields()
    }
  }))

  return (<div style={{ width: "100%" }}>
    <Form
      layout="vertical"
      form={form}
      showLabelColon
      scrollToFirstError
      initialValues={showData}
      onValuesChange={(changedValues, allValues) => {
        handleChange(allValues)
      } }
    >
      { dataList?.map?.((item, index) => {
        return <Row gutter={[24, 16]} key={index}>
          {
            UserFormItems.map((item, ii) => {
              const { label, formItemKey, required, col, elementProps } = item
              return (
                <Col span={col || 6} key={ii}>
                  <SFormItem
                    view={view}
                    style={{ width: "100%" }}
                    label={label}
                    formItemKey={`${index}_${formItemKey}`}
                    required={required}
                    renderData={{}}
                    componentClass={item.componentClass}
                    show={true}
                    elementProps={elementProps}
                  />
                </Col>
              )
            })
          }
        </Row>
      })}
    </Form>
  </div>)
})

export default UserList;
